var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14737 9.9518C2.35735 8.57426 1.97589 7.4494 1.74588 6.30918C1.4057 4.62282 2.18419 2.97551 3.47383 1.9244C4.01889 1.48016 4.64371 1.63194 4.96602 2.21017L5.69367 3.51559C6.27042 4.55031 6.5588 5.06767 6.5016 5.61616C6.4444 6.16466 6.05549 6.61139 5.27766 7.50484L3.14737 9.9518ZM3.14737 9.9518C4.74644 12.7401 7.25588 15.2509 10.0474 16.8518M10.0474 16.8518C11.4249 17.6418 12.5498 18.0233 13.69 18.2533C15.3764 18.5935 17.0237 17.815 18.0748 16.5254C18.519 15.9803 18.3672 15.3555 17.789 15.0332L16.4836 14.3055C15.4489 13.7288 14.9315 13.4404 14.383 13.4976C13.8345 13.5548 13.3878 13.9437 12.4943 14.7215L10.0474 16.8518Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.068b9aa154d718f56c65d24f91647319.svg";
export { ForwardRef as ReactComponent };